import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { RevealDirective } from '../../../core/directives/reveal.directive';

@Component({
  selector: 'app-problema',
  imports: [TranslatePipe, RevealDirective],
  templateUrl: './problema.html',
  styleUrl: './problema.scss',
})
export class Problema {}
